import React, { useState } from "react";
import {
  Box,
  Container,
  Divider,
  Icon,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import Navbar from "../Navbar";
import Toast from "../Toast";

import { getVars } from "@utils/global";
import { useMobileServices } from "@hooks/MobileDiaD/MobileServices";
import FormTransmision from "./FormTransmision";

const ScreenTransmision = ({ setTypeScreen }) => {
  const { snackbar, setSnackbar } = useMobileServices();

  const {
    ruta_rg: { Ruta, Descripcion, Casillas },
  } = getVars("Token");

  const [showForm, setShowForm] = useState(false);
  const [casilla, setCasilla] = useState(null);

  const handleClickItem = (casilla) => {
    setShowForm(true);
    setCasilla(casilla);
  };

  return (
    <>
      {!showForm ? (
        <>
          <Toast
            open={snackbar.show}
            message={snackbar.message}
            setOpen={setSnackbar}
          />

          <Navbar
            isScreen
            screenBack={"rgs"}
            title={"Medio de transmisión Ruta RG"}
            setTypeScreen={setTypeScreen}
            color="black"
          />

          <Container sx={{ mt: 4 }}>
            <Typography textAlign={"center"} fontWeight={600} marginBottom={2}>
              Transmisión
            </Typography>

            <Box textAlign={"center"} marginBottom={2}>
              <Typography variant="subtitle1" fontWeight={600}>
                {Ruta}
              </Typography>
              <Typography variant="subtitle1" fontWeight={600}>
                {Descripcion}
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" marginBottom={1} textAlign={"center"}>
                Seleccione la casilla que va a transmitir
              </Typography>
              <List>
                {Casillas &&
                  Casillas.map((casilla, index) => (
                    <div key={index}>
                      <ListItem
                        secondaryAction={<Icon>keyboard_arrow_right</Icon>}
                        onClick={() => handleClickItem(casilla)}
                      >
                        <ListItemText
                          primary={`${casilla.Seccion} - ${casilla.NombreCasilla}`}
                        />
                      </ListItem>
                      {index !== Casillas.length - 1 && <Divider />}
                    </div>
                  ))}
              </List>
            </Box>
          </Container>
        </>
      ) : (
        <FormTransmision
          idCasilla={casilla.idCasilla}
          NombreCasilla={casilla.NombreCasilla}
          Seccion={casilla.Seccion}
          setShowForm={setShowForm}
        />
      )}
    </>
  );
};

export default ScreenTransmision;
